export const buildStaffInviteRedirectUrl = (
  appClientDomain: string,
  clinicId: string,
): string => {
  const redirectUrl = new URL(`${appClientDomain}setup-password`);
  redirectUrl.searchParams.set("clinic_id", clinicId);
  return redirectUrl.toString();
};
